'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTheme = setTheme;
var SET_THEME = exports.SET_THEME = 'SET_THEME';

function setTheme(theme) {
  return {
    type: SET_THEME,
    payload: theme
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Container components/MuiThemeProviderContainer/actions.js
 ** module id = 171
 ** module chunks = 0
 **/